// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-down-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.5003 12.9L12.9003 21L12.0464 20.7154C10.9439 20.3479 10.2003 19.3161 10.2003 18.154V14.7H5.33148C4.10571 14.7 3.16835 13.6074 3.35474 12.3959L4.53936 4.69589C4.68946 3.72022 5.52896 3 6.5161 3H16.5003V12.9Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.5 12.9005V3.00049H21V12.9005H16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5003 3V12.9M16.5003 3H21.0003V12.9H16.5003M16.5003 3H6.5161C5.52896 3 4.68946 3.72022 4.53936 4.69589L3.35474 12.3959C3.16835 13.6074 4.10571 14.7 5.33148 14.7H10.2003V18.154C10.2003 19.3161 10.9439 20.3479 12.0464 20.7154L12.9003 21L16.5003 12.9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbDown2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-down-2',
    ref,
    icon: element,
  },
));

ThumbDown2Icon.displayName = 'ThumbDown2Icon';

export default ThumbDown2Icon;
